import "./App.css";
import Table from "./components/table/Table";

function App() {
  return (
    <div>
      <Table />
    </div>
  );
}

export default App;
